import { useTranslation } from 'react-i18next'
import { Tabs } from 'vnetwork-ui'

import SubHeaders from '@/components/Headers/SubHeaders'
import useTabs from '@/hooks/useTabs'
import { paths } from '@/utils/path'

import ReceivedList from './components/ReceivedList'
import AwaitingList from './components/AwaitingList'

// "Điểm của tôi" — self-scoped, auth-only (KHÔNG gate phòng ban như MyIncomes:
// ai cũng có thể bị chấm nên phải xem được điểm của mình).
const MyRatings = () => {
    const { t } = useTranslation('rating')

    const { TabProps, TabComponent } = useTabs({
        tabs: [
            {
                label: t('page.tab_received'),
                value: 'received',
                component: <ReceivedList />,
            },
            {
                label: t('page.tab_awaiting'),
                value: 'awaiting',
                component: <AwaitingList />,
            },
        ],
    })

    return (
        <div className="space-y-2">
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    { path: paths.account, title: t('page.account') },
                    { path: '', title: t('page.title') },
                ]}
            />
            <div className="rounded-lg border border-gray-200 bg-white p-3">
                <Tabs {...TabProps} />
                <div className="mt-3">{TabComponent}</div>
            </div>
        </div>
    )
}

export default MyRatings
